import classNames from 'classnames';
import { useAppContext } from 'providers/AppProvider';
import { Navbar } from 'react-bootstrap';
import logo from 'assets/images/fm_icon_x60.png';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import NavbarToggleButton from './NavbarToggleButton';
import { Link } from 'react-router-dom';
import useSiteConfig from 'hooks/useSiteConfig';

const NavbarBrand = () => {
  const {
    config: { navbarTopShape, navbarPosition }
  } = useAppContext();
  const { breakpoints } = useBreakpoints();
  const siteConfig = useSiteConfig();

  const logoSrc = siteConfig?.LogoUrl || logo;
  const brandTitle =
    siteConfig?.SiteName ||
    siteConfig?.Title ||
    process.env.REACT_APP_TITLE ||
    'Flexmerch';
  const tagline = siteConfig?.Tagline;

  return (
    <>
      <div className="navbar-logo">
        {breakpoints.down('lg') && <NavbarToggleButton />}
        <Navbar.Brand
          as={Link}
          to="/"
          className={classNames({
            'me-1 me-sm-3':
              navbarTopShape === 'slim' || navbarPosition === 'horizontal'
          })}
        >
          {navbarTopShape === 'slim' ? (
            <>
              {brandTitle}{' '}
              <span className="text-1000 d-none d-sm-inline">slim</span>
            </>
          ) : (
            <div className="d-flex align-items-center">
              <img
                src={logoSrc}
                alt={brandTitle}
                style={{ maxHeight: '27px', width: 'auto' }}
              />
              <div className="ms-2 d-none d-sm-block">
                <p className="logo-text">{brandTitle}</p>
                {tagline && (
                  <p className="text-body-tertiary mb-0 fs-10 fw-normal">
                    {tagline}
                  </p>
                )}
              </div>
            </div>
          )}
        </Navbar.Brand>
      </div>
    </>
  );
};

export default NavbarBrand;
